'use strict';
require("stylesheets/components/exampleOverlay.scss");
require("stylesheets/lib/d3-tip.scss");

//TODO: horizontal nodes are now overlapping
//TODO: reverse lookup. highlight on nodes at bottom, up

var chroma = require("chroma-js"),
    d3 = require("d3"),
    d3tip = require("d3-tip")(d3);

var {ruleColorMap,
     annotationColor,
     annotationHighlightColor} = require("./colorScheme.js");

var {grammar, semantics} = require("../../../language.js"),
    treeUtils = require("../../../treeUtils.js");
var {EventGenerator} = require("../../eventGenerator.js");

var {initSemantics} = require("./semantics.js");

//TODO: global semantics provides utilities. Local semantics provides specific functionality
class ExampleOverlay extends EventGenerator {
  constructor(svg, {match, exampleView, actions}){
    super();

    //clear svg children
    // call constructor to reinitialize
    while (svg.firstChild) {
      svg.removeChild(svg.firstChild);
    }
    this.svg = d3.select(svg);

    this._initVisualizationGlobals();

    this.semantics = initSemantics(this, null);

    this.match = match;
    this.semmatch = this.semantics(this.match);
    this.exampleView = exampleView;

    //TREE PROPERTIES
    this.treeProperties = {
      maxDepth: this.semmatch.augment(0, -1, null, [])
    };

    //PARAMETERS
    let lineHeight = window.getComputedStyle(this.semmatch.dom).lineHeight;
    lineHeight = parseInt(lineHeight.slice(0, lineHeight.indexOf('px')));

    let annotationWidth = 1.5;

    //do we use bounds?
    Object.assign(this, svg.getBoundingClientRect());
    svg.closest('example').style.paddingLeft = annotationWidth*(this.treeProperties.maxDepth+1)
    Object.assign(this, svg.getBoundingClientRect());

    this.parameters = {
      annotationWidth,
      lineHeight
    };

    this._initVisualization();
  }

  _initVisualizationGlobals(){
    this.tooltip = d3.tip()
      .attr('class', 'd3-tip')
      .direction(function(n){
        if(n.drawOrientation === 'vertical'){
          return 'e';
        } else if(n.drawOrientation === 'horizontal'
                  || n.drawOrientation === 'horizontal_extra'){
          return 's';
        }
      })
      .html(function(n) {
        let label = n.ctorName;
        if(n.hasOwnProperty('lineStart')){
          n = n.node;
          label = n.ctorName;
        }

        if(n.ctorName === '_iter'){
          label = n.children.length > 0?
            `iter&lt;${n.children[0].ctorName}&gt;`: 'iter';
        } else if(n.ctorName === '_terminal'){
          label = 'terminal';
        }

        if(n.drawOrientation === 'vertical' && n.overlappingSiblings){
          label += '…';
        }

        return label;
      });
    this.svg.call(this.tooltip);
  }

  _initVisualization(){
    // let verticalAnnotationNodes = [];
    // let horizontalAnnotationNodes = [];
    //
    // this.semmatch.vhBuckets(
    //   verticalAnnotationNodes, horizontalAnnotationNodes,
    //   true
    // );
    //
    // this._initVerticalAnnotations(verticalAnnotationNodes);
    // this._initHorizontalAnnotations(horizontalAnnotationNodes, verticalAnnotationNodes);

    this._initGlobal();
    // this._initLocal();
  }

  _initGlobal(){
    //data manipulation
    this._initData();
    //setup operations
    this._initVerticalAnnotations();
    this._initHorizontalAnnotations();

  }

  _initData(){
    let verticalNodes = [];
    let horizontalNodes = [];

    this.semmatch.vhBuckets(
      verticalNodes, horizontalNodes,
      true
    );

    //GROUP NODES BY LINE
    let horizontalGroups = {};
    let lineStarts = [];
    horizontalNodes.forEach(node=>{
      if(!horizontalGroups.hasOwnProperty(node.bounds.top)){
        horizontalGroups[node.bounds.top] = [];
        lineStarts.push(node.bounds.top);
      }
      horizontalGroups[node.bounds.top].push(node);
    });

    let lineData = [];
    lineStarts.forEach(lineStart=>{
      let nodes = horizontalGroups[lineStart];
      lineData.push({start: lineStart, nodes, verticalNodes: []});
    });

    lineData.forEach(line=>{
      let {nodes} = line;
      line.minDepth =
        nodes.reduce((agg, b)=>
          (!agg || b.depth < agg)? b.depth: agg
        , nodes[0].depth);
      line.maxDepth =
        nodes.reduce((agg, b)=>
          (!agg || b.depth > agg)? b.depth: agg
        , nodes[0].depth);
    });

    verticalNodes.forEach(node=>{
      if(node.interval.contents.includes('\n')){
        lineData.forEach(line=>{
          //if node covers this line, add it to the group
          if(node.bounds.top <= line.start && line.start < node.bounds.bottom
             && line.minDepth <= node.depth && node.depth <= line.maxDepth){
            line.verticalNodes.push({lineStart: line.start, node, ctorName: node.ctorName});
          }
        })
      }
    });

    lineData.forEach(line=>{
      line.nodes.forEach(node=>{
        node.relativeDepth = node.depth - line.minDepth;
      });
      line.verticalNodes.forEach((extra)=>{
        let {node} = extra;
        extra.relativeDepth = node.depth - line.minDepth;
      });
    });

    this.data = {};
    Object.assign(this.data, {verticalNodes, horizontalNodes, lineData});
  }

  _getDatums(datum, drawOrientation){
    let verticalDatum, horizontalDatum, node;
    if(drawOrientation === 'vertical'){
      verticalDatum = datum;
      node = datum._node;
      let curline;
      if(curline = this.data.lineData.find(line=> line.expanded)){
        horizontalDatum = curline.verticalNodes.find(extra => nodeKey(extra.node) === nodeKey(datum));
        horizontalDatum = horizontalDatum || curline.nodes.find(node=> nodeKey(node) === nodeKey(datum));
      }
    } else if(drawOrientation === 'horizontal'){
      node = datum._node;
      horizontalDatum = datum;
      verticalDatum = this.data.verticalNodes.find(node=> nodeKey(node) === nodeKey(datum));
    } else if(drawOrientation === 'horizontal_extra'){
      node = datum.node._node;
      horizontalDatum = datum;
      verticalDatum = this.data.verticalNodes.find(node=> nodeKey(node) === nodeKey(datum.node));
    } else {
      throw `unknown orientation ${drawOrientation}`;
    }

    return {verticalDatum, horizontalDatum, node};
  }

  _highlight(datum, drawOrientation){
    let {node, verticalDatum, horizontalDatum} = this._getDatums(datum, drawOrientation);

    //call highlightAnnotation with a particular draw orientation
    this._sendEvent('highlight', {
      node,
      action: ()=>{
        this._highlightVertical(verticalDatum, drawOrientation==='vertical');
        this._highlightHorizontal(horizontalDatum, drawOrientation.includes('horizontal'));
      }
    });
  }
  _highlightVertical(d, tooltip){
    if(!d){ return; }
    if(tooltip){
      d.drawOrientation = 'vertical';
    }
    this.highlightAnnotation(this.selections.verticalAnnotations, d, tooltip);
  }
  _highlightHorizontal(d, tooltip){
    if(!d){ return; }
    if(tooltip){
      d.drawOrientation = 'horizontal';
    }
    let selection = d.hasOwnProperty('lineStart')? this.selections.lineExtraNodes:
                                                   this.selections.lineNodes;

    this.highlightAnnotation(selection, d, tooltip);
  }

  _unHighlight(datum, drawOrientation){
    //get vertical and horizontal datums
    let {node, verticalDatum, horizontalDatum} = this._getDatums(datum, drawOrientation);

    //call highlightAnnotation with a particular draw orientation
    this._sendEvent('unHighlight', {
      node,
      action: ()=>{
        this._unHighlightVertical(verticalDatum, drawOrientation==='vertical');
        this._unHighlightHorizontal(horizontalDatum, drawOrientation.includes('horizontal'));
      }
    });
  }
  _unHighlightVertical(d, tooltip){
    if(!d){ return }
    this.unHighlightAnnotation(this.selections.verticalAnnotations, d, tooltip);
  }
  _unHighlightHorizontal(d, tooltip){
    if(!d){ return }
    let selection = d.hasOwnProperty('lineStart')? this.selections.lineExtraNodes:
                                                   this.selections.lineNodes;
    this.unHighlightAnnotation(selection, d, tooltip);
  }

  _toggle(line){
    console.log('toggle');
    this._toggleVertical(line);
    this._toggleHorizontal(line);
  }
  _toggleVertical(line){
    console.log('toggle vertical!');
    let that = this;
    let pushDownAmount = (line.maxDepth - line.minDepth) * this.parameters.annotationWidth;

    //move lines below down
    var collapseLine = (line) => {
      let that = this;
      let pushDownAmount = (line.maxDepth - line.minDepth) * this.parameters.annotationWidth;
      let currentAnnotations = this.selections.verticalAnnotations
                                 .filter(n=> n.bounds.top <= line.start && line.start < n.bounds.bottom)
      currentAnnotations
        .attr('transform', function(n){
          let transform = d3.transform(d3.select(this).attr('transform'));
          let scaleAmt = 1;
          transform.translate[1] -= (scaleAmt-transform.scale[1])*(n.bounds.top-that.svg[0][0].getBoundingClientRect().top);
          transform.scale[1] = scaleAmt;
          return transform.toString();
        });

      let annotationsAfter = this.selections.verticalAnnotations
                               .filter(n=> n.bounds.top > line.start);
      annotationsAfter
        .attr('transform', function(n){
          let transform = d3.transform(d3.select(this).attr('transform'));
          transform.translate[1] -= pushDownAmount;
          return transform.toString();
        });
    }

    if(line.expanded){
      collapseLine(line);
    } else {
      //collapse other lines
      let otherExpandedLines = this.data.lineData.filter(l=> l!==line && l.expanded);
      otherExpandedLines.forEach(l=> collapseLine(l));

      //stretch nodes on this line to take up maxDepth
      let currentAnnotations = this.selections.verticalAnnotations
                                   .filter(n=> n.bounds.top <= line.start && line.start < n.bounds.bottom);
      currentAnnotations.transition()
      .duration(100)
      .ease('linear')
      .attr('transform', function(n){
        let nodeHeight = n.bounds.bottom - n.bounds.top;
        let newHeight = nodeHeight + pushDownAmount;

        let transform = d3.transform(d3.select(this).attr('transform'));
        let scaleAmt = newHeight/nodeHeight;
        transform.translate[1] -= (scaleAmt-transform.scale[1])*(n.bounds.top-that.svg[0][0].getBoundingClientRect().top);
        transform.scale[1] = scaleAmt;

        return transform.toString();
      });

      //move lines below down
      let annotationsAfter = this.selections.verticalAnnotations
        .filter(n=> n.bounds.top > line.start);
      annotationsAfter.transition()
      .duration(100)
      .ease('linear')
      .attr('transform', function(n){
        let transform = d3.transform(d3.select(this).attr('transform'));
        transform.translate[1] += pushDownAmount;
        return transform.toString();
      });

    }
  }

  _showLine(line){
    this.selections.horizontalAnnotations.filter(l=> l===line)
      .selectAll('path.horizontal').transition()
      .duration(100)
      .ease('linear')
      .style('opacity', 1);
  }
  _hideLine(line){
    this.selections.horizontalAnnotations.filter(l=> l===line)
      .selectAll('path.horizontal').transition()
      .duration(100)
      .ease('linear')
      .style('opacity', 0);
  }
  _toggleHorizontal(line){
    let that = this;
    var collapseLine = (line) => {
      let currentLineNodes = that.selections.horizontalAnnotations
                                   .filter(l=> l===line)
                                   .selectAll('path.horizontal');
      let linesAfter = that.selections.horizontalAnnotations
                             .filter(l=> l.start > line.start);

      currentLineNodes
        .attr('transform', n=> `translate(0, -${that.parameters.annotationWidth*n.relativeDepth})`);
      linesAfter
        .attr('transform', 'translate(0,0)');

      let node = line.nodes.find(n => n.interval.contents.length > 0) || line.nodes[0];
      node.dom.style.display = 'initial';
      node.dom.style.marginBottom = 'initial';

      line.expanded = false;
    };

    let currentLineNodes = this.selections.horizontalAnnotations
                                 .filter(l=> l===line)
                                 .selectAll('path.horizontal');
    let otherLines = this.selections.horizontalAnnotations
                           .filter(l=> l!==line);
    let otherLineNodes = otherLines
                           .selectAll('path.horizontal');
    let linesAfter = this.selections.horizontalAnnotations
                            .filter(l=> l.start > line.start);
    let linesBefore = this.selections.horizontalAnnotations
                            .filter(l=> l.start <= line.start);

    if(line.expanded){
      collapseLine(line);
    } else {
      otherLines.each(line=> {
        collapseLine(line);
        that._hideLine(line);
      });

      currentLineNodes.transition()
        .duration(100)
        .ease('linear')
        .attr('transform', 'translate(0,0)');

      let pushDown = that.parameters.annotationWidth*(line.maxDepth-line.minDepth+1);

      linesAfter.transition()
        .duration(100)
        .ease('linear')
        .attr('transform', `translate(0, ${pushDown})`);

      let node = line.nodes.find(n => n.interval.contents.length > 0) || line.nodes[0];
      node.dom.style.display = 'inline-block';
      node.dom.style.marginBottom = pushDown;

      line.expanded = true;
    }
  }


  _initVerticalAnnotations(){
    let that = this;
    let verticalAnnotations = this.svg.selectAll('path.vertical.annotation')
      .data(this.data.verticalNodes, nodeKey);

    if(!this.hasOwnProperty('selections')){
      this.selections = {};
    }

    verticalAnnotations.enter().append('path')
      .attr('class', n => `vertical annotation ${nodeKey(n)}`);

    let cumDelta = 0, threshold = 50;
    verticalAnnotations
      .attr('d', function(d, i) { return 'M' + d.verticalPath.join('L') + 'Z'; })
      .style('fill', 'none')
      .style('stroke', (d) => {
        let color = ruleColorMap.get(d.ctorName) || annotationColor;
        return color.css()
      })
      .style('stroke-width', this.parameters.annotationWidth+'px')
      .on('mouseover', function(d){
        that._highlight(d, 'vertical');
      })
      .on('mouseout', function(d){
        that._unHighlight(d, 'vertical');
      })
      .on('click', function(d){ //expand collapsed vertical nodes
        let descendants = d.siblings
          .map(n => treeUtils.descendants(n))
          .reduce((agg, b) => agg.concat(b), []);

        let level = [...d.siblings, d];
        let expand = !d.expanded;

        verticalAnnotations.transition()
          .duration(100)
          .ease('linear')
          .attr('transform', function(ann){
            let transform = d3.transform(d3.select(this).attr('transform'));
            transform.translate[0] = 0;
            return transform.toString();
          })
          .each(d => d.expanded = false);

        if(expand) {
          level.sort((a, b) =>
            a.bounds.top < b.bounds.top? -1:
              a.bounds.top > b.bounds.top? 1:
                a.dom.offsetLeft < b.dom.offsetLeft? -1:
                a.dom.offsetLeft > b.dom.offsetLeft? 1: 0
          );

          let relevantBars = verticalAnnotations.filter(d => descendants.includes(d));
          relevantBars.transition()
            .duration(100)
            .ease('linear')
            .attr('transform', function(ann){
              let transform = d3.transform(d3.select(this).attr('transform'));
              transform.translate[0] = that.parameters.annotationWidth*(d.siblings.length+2);
              console.log('relevant', transform.toString());
              return transform.toString();
            });

          let levelBars = verticalAnnotations.filter(d=> level.includes(d));
          levelBars.transition()
            .duration(100)
            .ease('linear')
            .attr('transform', function(ann){
              let transform = d3.transform(d3.select(this).attr('transform'));
              transform.translate[0] = that.parameters.annotationWidth*(level.indexOf(ann)+2);
              console.log('level', transform.toString());
              return transform.toString();
            });

          level.forEach(d => d.expanded = true);
        }
      });

    Object.assign(this.selections, {verticalAnnotations});
  }

  _initHorizontalAnnotations(){
    let that = this;
    let {width, top: parentTop, left: parentLeft} = this.svg[0][0].getBoundingClientRect();

    let {lineData} = this.data;
    if(!this.hasOwnProperty('selections')){
      this.selections = {};
    }

    //horizontalAnnotations => lines
    let horizontalAnnotations = this.svg.selectAll('g.line')
      .data(lineData, line=>line.start);
    horizontalAnnotations.enter().append('g')
      .attr('class', line=> `line ${line.start}`);

    //horizontal-specific behaviours

    //lineTargets => mouseover targets
    let lineTargets = horizontalAnnotations.selectAll('rect.lineTarget')
      .data(function(line){
        return [line];
      }, line=>line.start);
    lineTargets.enter().append('rect')
      .attr('class', line=> `lineTarget ${line.start}`);

    lineTargets
      .attr('x', this.semmatch.bounds.left - parentLeft)
      .attr('y', n=> n.start -parentTop)
      .attr('width', width)
      .attr('height', this.parameters.lineHeight)
      .style('stroke', 'none')
      .style('fill', 'none')
      .on('mouseover', (line) => !line.expanded? that._showLine(line): nop())
      .on('mouseout' , (line) => !line.expanded? that._hideLine(line): nop())
      .on('click', (line)=> that._toggle(line));


    //lineExtraNodes => nodes in each line that refer to the left
    let lineExtraNodes = horizontalAnnotations.selectAll('path.horizontal.extra')
      .data(line=>line.verticalNodes, ({lineStart, node})=> `${lineStart}:${nodeKey(node)}`);
    lineExtraNodes.enter().append('path')
      .attr('class', ({lineStart, node})=> `horizontal extra ${lineStart}:${nodeKey(node)}`)
      .on('mouseover', function(d){
        that._highlight(d, 'horizontal_extra');
      })
      .on('mouseout', function(d){
        that._unHighlight(d, 'horizontal_extra');
      })
      .on('click', function({lineStart, node}){
        let line = lineData.find(line=> line.start === lineStart);
        that._toggle(line);
      });

    lineExtraNodes
      .attr('d', function({lineStart, node, relativeDepth}){
        let line = lineData.find(line=> line.start === lineStart);
        return `M${node.horizontalPathForLine(line, relativeDepth)}`;
      })
      .style('fill', 'none')
      .style('stroke', ({node}) => {
        let color = ruleColorMap.get(node.ctorName) || annotationColor;
        return color.css()
      })
      .style('stroke-width', this.parameters.annotationWidth+'px')
      .style('opacity', 0)
      .attr('transform', ({relativeDepth})=> `translate(0, -${that.parameters.annotationWidth*relativeDepth})`);


    //lineNodes => nodes in each line that don't refer to the left
    let lineNodes = horizontalAnnotations.selectAll('path.horizontal.annotation')
      .data(line=>line.nodes, nodeKey);
    lineNodes.enter().append('path')
      .attr('class', n=> `horizontal annotation ${nodeKey(n)}`)
      .style('z-index', 1)
      .on('mouseover', function(node){
        that._highlight(node, 'horizontal');
      })
      .on('mouseout', function(node){
        that._unHighlight(node, 'horizontal');
      })
      .on('click', function(node){//TODO: set flag to indicate this line is expanded
        let line = lineData.find(line=> line.start === node.bounds.top);
        that._toggle(line);
      });

    lineNodes
      .attr('d', function(d){return `M${d.horizontalPath.join('L')}Z`;})
      .style('fill', 'none')
      .style('stroke', (d) => {
        let color = ruleColorMap.get(d.ctorName) || annotationColor;
        return color.css()
      })
      .style('stroke-width', this.parameters.annotationWidth+'px')
      .style('opacity', 0)
      .attr('transform', n=> `translate(0, -${that.parameters.annotationWidth*n.relativeDepth})`);

    Object.assign(this.selections, {lineNodes, lineExtraNodes, lineTargets, horizontalAnnotations});
  }

  //PUBLIC ACTION FUNCTIONS
  highlightAnnotation(selection, datum, tooltip = true){
    find(selection, datum)
      .style('stroke', annotationHighlightColor.css('hsl'));
    if(tooltip){
      this.tooltip.show(datum);
    }
  }

  unHighlightAnnotation(selection, datum, tooltip = true){
    find(selection, datum)
      .style('stroke', (d) => {
        let color = ruleColorMap.get(d.ctorName) || annotationColor;
        return color.css()
      });
    if(tooltip){
      this.tooltip.hide(datum);
    }
  }
}

var toExport = {
  ExampleOverlay
};

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}


function find(selection, datum){
  return selection.filter(d => d === datum);
}

function nodeKey(n){
  let keyStr = `${n.ctorName},${n.interval.startIdx},${n.interval.endIdx},${n.uuid}`;
  return keyStr;
}

function nop(){}



/** WEBPACK FOOTER **
 ** ./src/components/exampleRepresentation/visualizationOverlay/index.js
 **/